<div class="messages-page" [class.mobile]="isMobile()">
  @if (showList()) {
    <section class="list-pane">
      <div class="list-header">
        <h4 class="card-title">Messages</h4>
        @if (isMobile() && selectedId()) {
          <button mat-stroked-button type="button" class="back-to-chat" (click)="listOpen.set(false)">
            Back to chat
            <mat-icon iconPositionEnd>chevron_right</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          type="button"
          aria-label="Message settings"
          matTooltip="Message settings"
          (click)="openSettings()"
        >
          <mat-icon>tune</mat-icon>
        </button>
      </div>

      <div class="list-tools">
        <div class="search">
          <mat-icon>search</mat-icon>
          <input
            type="search"
            [formControl]="searchControl"
            placeholder="Search shopper or product"
            aria-label="Search messages"
          />
          @if (searchControl.value) {
            <button type="button" class="clear" aria-label="Clear search" (click)="clearSearch()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
        <button
          type="button"
          class="filter-chip"
          [class.active]="unreadOnly()"
          [attr.aria-pressed]="unreadOnly()"
          (click)="toggleUnread()"
        >
          @if (unreadOnly()) {
            <mat-icon>check</mat-icon>
          }
          Unread
        </button>
      </div>

      <div class="list">
        @if (loading()) {
          <div class="list-state"><mat-spinner diameter="28"></mat-spinner></div>
        } @else if (listError()) {
          <div class="list-state">
            <p>{{ listError() }}</p>
            <button mat-stroked-button type="button" (click)="loadList()">Try again</button>
          </div>
        } @else {
          @for (c of conversations(); track c.id) {
            <button
              type="button"
              class="row"
              [class.selected]="c.id === selectedId()"
              [class.unread]="c.vendorUnread > 0"
              (click)="open(c)"
            >
              <fh-chat-image class="row-avatar" [path]="c.buyerPicture" [alt]="c.buyerName" />
              <span class="row-main">
                <span class="row-top">
                  <span class="row-name">{{ c.buyerName }}</span>
                  @if (c.lockedAt) {
                    <mat-icon class="row-flag locked" matTooltip="Closed by FishyHub">lock</mat-icon>
                  }
                  @if (c.flaggedAt) {
                    <mat-icon class="row-flag flagged" matTooltip="Flagged for review by FishyHub">flag</mat-icon>
                  }
                  <span class="row-time">{{ relativeTime(c.lastMessageAt) }}</span>
                </span>
                <span class="row-bottom">
                  <span class="row-preview">
                    @if (c.lastSenderRole === "vendor") {
                      <span class="you">You: </span>
                    }
                    {{ c.lastMessagePreview || "" }}
                  </span>
                  @if (c.vendorUnread > 0) {
                    <span class="row-badge">{{ c.vendorUnread > 99 ? "99+" : c.vendorUnread }}</span>
                  }
                </span>
              </span>
            </button>
          } @empty {
            <div class="list-state empty">
              <mat-icon>forum</mat-icon>
              @if (search() || unreadOnly()) {
                <p>No messages match.</p>
              } @else {
                <p>No messages yet. When shoppers message your store, they'll appear here.</p>
              }
            </div>
          }

          @if (hasMore()) {
            <div class="load-more">
              <button mat-stroked-button type="button" [disabled]="loadingMore()" (click)="loadMore()">
                {{ loadingMore() ? "Loading…" : "Load more" }}
              </button>
            </div>
          }
        }
      </div>
    </section>
  }

  @if (showConversation()) {
    <!-- Kept (hidden) while the list is shown on small screens, so going back is instant -->
    <section class="conversation-pane" [class.hidden]="isMobile() && showList()">
      @if (selectedId(); as id) {
        <fh-conversation
          [conversationId]="id"
          [quickReplies]="quickReplies()"
          [showBack]="isMobile()"
          (back)="listOpen.set(true)"
          (activity)="refreshList()"
          (hidden)="onHidden($event)"
          (openSettings)="openSettings()"
        />
      } @else {
        <div class="no-selection">
          <mat-icon>forum</mat-icon>
          <p>Select a conversation to read and reply.</p>
        </div>
      }
    </section>
  }
</div>
